"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      searchData: {
        page: 1,
        rows: 10 },

      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },
      //分页数据
      tableData: [''], //表格数据
      tableColumns: [
      {
        label: '国家地区',
        prop: 'countryRegionalName' },

      {
        label: '品牌',
        prop: 'brandCode' },

      {
        label: '邮箱',
        prop: 'email' }],

      //表头数据
      showAdd: false, //是否显示新增||编辑弹窗
      countryForm: {
        id: 0,
        countryRegionalId: '',
        country: '',
        brandCode: '',
        email: '',
        createTime: '' },
      //新增||编辑表单
      countryFormRule: {
        brandCode: [{
          required: true,
          message: '请选择品牌',
          trigger: ['change'] }],

        email: [{
          required: true,
          message: '请填写邮箱',
          trigger: ['change', 'blur'] }] },

      //新增||编辑表单校验规则
      brandList: [], //品牌列表
      parentId: 0, //父级id
      parentName: '' //父级名称
    };
  },

  mounted: function mounted() {
    this.parentId = this.$route.params.parentId;
    this.parentName = this.$route.params.parentName;
    this.$set(this.searchData, 'countryRegionalId', this.parentId);
    this.$set(this.countryForm, 'countryRegionalId', this.parentId);
    this.$set(this.countryForm, 'country', this.parentName);
    this.initPage();
  },

  methods: {
    /**
              * 页面初始化
              */
    initPage: function initPage() {
      this.fetchList();
      this.fetchBrandList();
    },

    /**
        * 获取列表
        */
    fetchList: function fetchList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/faCountryRegional/getServiceNotification', params, function (res) {
        _this.tableData = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取品牌列表
        */
    fetchBrandList: function fetchBrandList() {var _this2 = this;
      var params = {
        page: 1,
        rows: 9999 };

      this.getData('/api/faBrandInfo', params, function (res) {
        _this2.brandList = res.list;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'name', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchList();
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.searchData, 'page', 1);
      this.$set(this.searchData, 'rows', val);
      this.fetchList();
    },

    /**
        * Page-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'page', val);
      this.fetchList();
    },

    /**
        * 编辑
        */
    editItem: function editItem(row) {
      this.showAdd = true;
      this.$set(this.countryForm, 'id', row.id);
      this.$set(this.countryForm, 'brandCode', row.brandCode);
      this.$set(this.countryForm, 'email', row.email);
      this.$set(this.countryForm, 'createTime', row.createTime);
    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this3 = this;
      this.$confirm('确定删除当前项？', '提示', { type: 'warning' }).then(function (res) {
        //删除通知
        _this3.delData("/api/faCountryRegional/deleteServiceNotification/".concat(row.id), {}, function (res) {
          _this3.fetchList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 弹窗打开
        */
    onAddDialogOpen: function onAddDialogOpen() {var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.countryForm.clearValidate();
      });
    },

    /**
        * 新增||编辑弹窗关闭
        */
    onAddDialogClose: function onAddDialogClose() {var _this5 = this;
      this.$nextTick(function () {
        Object.keys(_this5.countryForm).forEach(function (e) {
          if (e == 'country') {
            _this5.$set(_this5.countryForm, e, _this5.parentName);
            return;
          }
          if (e == 'countryRegionalId') {
            _this5.$set(_this5.countryForm, e, _this5.parentId);
            return;
          }
          _this5.$set(_this5.countryForm, e, '');
        });
        _this5.$refs.countryForm.clearValidate();
      });
      this.showAdd = false;
    },

    /**
        * 保存
        */
    onSaveCountry: function onSaveCountry() {var _this6 = this;
      this.$refs.countryForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this6.countryForm);
          delete params['country'];
          if (params.id) {
            //编辑
          } else {
            //新增
            delete params['id'];
            delete params['createTime'];
          }
          _this6.postData('/api/faCountryRegional/saveServiceNotification', params, function (res) {
            _this6.showAdd = false;
            _this6.fetchList();
          });
        }
      });
    } } };exports.default = _default;